import React from 'react'
import styled from "styled-components"

const Horizontal = styled.div`
  display: flex;
  justify-content: ${props => props.justifyContent};
  width: ${props => props.width};
  align-items: ${props => props.alignItems};
`

const HorizontalAlign = ({content = "", width = "100%", alignItems = "top", justifyContent = "space-between", children}) => {
    return <Horizontal width={width} alignItems={alignItems} justifyContent={justifyContent}>{content}{children}</Horizontal>
}
export default HorizontalAlign
